<template>
    <div class="article-box m-0-a">
        <a class="article-item d-i-b m-0-a p-r" :href="item.path" v-for='(item,index) in info' :key='index' v-if="item.title">
            <div class="tab-box d-i-b">
                <span class="tab d-i-b t-a-c" :style="{background:fontInfo.activeColor}">{{item.type}}</span>
            </div>
            <div class="article-title d-i-b p-a mb-f-s-24" :style="{color:fontInfo.activeColor}">{{item.title}}</div>
        </a>
    </div>
</template>
<style lang="less" scoped>
    .article-box {
        width: 10rem;
        min-height: 6rem;
    }
    .article-item {
        width: 9.653333rem;
        border-bottom: 1px solid #ccc;
        padding: .186667rem 0;
        overflow: hidden;
    }
    .tab-box {
        margin: 0 .4rem;
        .tab {
            width: 1.6rem;
            border-radius: 5px;
            line-height: .48rem;
            color: #fff;
            white-space: pre-wrap;
        }
        .tab~.tab {
            margin-top: .053333rem;
        }
    }
    .article-title {
        width: 78%;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        top: .2rem;
        left: 22%;
    }
</style>
<script>
    export default {
        props: ['info', 'fontInfo']
    }
</script>




// WEBPACK FOOTER //
// client/smsgz/components/guide/guide-article.vue